export function serializeScriptValue(value: object | string): string {
	return JSON.stringify(value).replace(
		/[<>&]/g,
		(character) => `\\u${character.charCodeAt(0).toString(16).padStart(4, "0")}`
	);
}

export function googleTagManagerCode(id: string): string {
	return `
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != "dataLayer" ? "\\x26l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, "script", "dataLayer", ${serializeScriptValue(id)});
`;
}
